
<div class="container">
 
  <div class="containerLogin login-container">
    <form [formGroup]="loginInformation" (ngSubmit)="onSubmit()">

      <div class="col-md-12 login-form-1">
        <a href="https://www.CanogaParkClassAction.com/" class="btn btn-primary">Exit to Return to the Settlement Website</a>
        <br />
        <br />

        <h3 class="misc-titles text-center">Class Area Address Search</h3>
        <div class="container" style="border:1px solid #bebaba">
          <br /><br />
                <p class="misc-titles">

                  <b>Street Number</b>: 4-5 Numerical Digits<br />
                  <b>Street Name</b>: examples, "Schoolcraft", "Hart" (exclude ST, AVE, WAY, etc.)<br />
                  <b>Zip Code</b>: 5 Numerical Digits<br />
                </p>
          <br /><br />
          <div class="form-group">
            <div class="row">
              <div class="col-md-6">
                <label for="streetNumber" style="font-weight:bold">Street Number: <span style="color:red" class="required"> *</span></label>
                <input type="text" class="form-control" formControlName="streetNumber" trim="blur" autocomplete="off"
                       [ngClass]="{ 'is-invalid': submitted && f.streetNumber.errors }" />
                <div *ngIf="submitted && f.streetNumber.errors" class="invalid-feedback">
                  <div *ngIf="f.streetNumber.errors.required">This field is required</div>
                  <div *ngIf="f.streetNumber.errors.minlength">This field must be at least 8 characters</div>
                  <div *ngIf="f.streetNumber.errors.maxlength">
                    This field must not be greater than 8 characters
                  </div>
                  <div *ngIf="f.streetNumber.errors.pattern">This field accepts only numerical digits 0-9 and characters A-Z</div>
                </div>
              </div>
              <div class="col-md-6">
                <label for="streetName" style="font-weight:bold">Street Name: (Do <b><u>NOT</u></b> include “St.”  “Way”  “Ave.”, etc.)<span style="color:red" class="required"> *</span></label>
                <input type="text" class="form-control" formControlName="streetName" trim="blur" autocomplete="off"
                       [ngClass]="{ 'is-invalid': submitted && f.streetName.errors }" />
                <div *ngIf="submitted && f.streetName.errors" class="invalid-feedback">
                  <div *ngIf="f.streetName.errors.required">This field is required</div>
                  <div *ngIf="f.streetName.errors.minlength">This field must be at least 8 characters</div>
                  <div *ngIf="f.streetName.errors.maxlength">
                    This field must not be greater than 8 characters
                  </div>
                  <div *ngIf="f.streetName.errors.pattern">This field accepts only numerical digits 0-9 and characters A-Z</div>
                </div>
              </div>
             
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-md-6">
                <label for="zip" style="font-weight:bold">Zip (5 Digits): <span style="color:red" class="required"> *</span></label>
                <input type="text" class="form-control" formControlName="zip" trim="blur" autocomplete="off"
                       [ngClass]="{ 'is-invalid': submitted && f.zip.errors }" />
                <div *ngIf="submitted && f.zip.errors" class="invalid-feedback">
                  <div *ngIf="f.zip.errors.required">This field is required</div>
                  <div *ngIf="f.zip.errors.minlength">This field must be at least 6 characters</div>
                  <div *ngIf="f.zip.errors.maxlength">
                    This field must not be greater than 6 characters
                  </div>
                  <div *ngIf="f.zip.errors.pattern">This field accepts only numerical digits 0-9 and characters A-Z</div>
                </div>
              </div>
              <div class="col-md-6">
                <label for="aptNumber" style="font-weight:bold">Unit Number:</label>
                <input type="text" class="form-control" formControlName="aptNumber" trim="blur" autocomplete="off"
                       [ngClass]="{ 'is-invalid': submitted && f.aptNumber.errors }" />
                <div *ngIf="submitted && f.aptNumber.errors" class="invalid-feedback">
                  <div *ngIf="f.aptNumber.errors.required">This field is required</div>
                  <div *ngIf="f.aptNumber.errors.minlength">This field must be at least 8 characters</div>
                  <div *ngIf="f.aptNumber.errors.maxlength">
                    This field must not be greater than 8 characters
                  </div>
                  <div *ngIf="f.aptNumber.errors.pattern">This field accepts only numerical digits 0-9 and characters A-Z</div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-12">
              You can also click <a href="./assets/documents/Northrop_PropertyAddressList (PDF).pdf" target="_blank">here</a> to see a list of all addresses within the Class Area.
            </div>

          </div>
          <br /><br />
          <div class="row">
            <div class="col-md-12 text-center">
              <div class="form-group">
                <button class="btn btn-primary" id="login" [disabled]="clicked">Submit</button>
              </div>
            </div>
          </div>
          <div class="row mt-3" *ngIf="showDivInClass == true">
            <div class="col-md-12 text-center" style="font-weight:bold; color:green; font-size:2.0em">
              This address is in the class! Click <a [routerLink]="['/login']">here</a> to file a claim.
            </div>
          </div>
          <div class="row mt-3" *ngIf="showDivNotInClass == true">
            <div class="col-md-12 text-center" style="font-weight:bold; color:red; font-size:2.0em">
              This address is Not in the class
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <img src="../../../assets/Class Area Map.jpg" class="img-responsive" style="width:80%;  display: block; margin: 0 auto;">
            </div>
          </div>
          <br />
          <br />
        </div>
        <br />
      </div>


    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
  </div>
</div>
